<!-- 交付项目管理 -->
<template>
    <basicContainer>
        <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
            <el-tab-pane label="交付项目" name="1"></el-tab-pane>
            <el-tab-pane label="关闭项目" name="2"></el-tab-pane>
            <el-tab-pane label="运维项目" name="3"></el-tab-pane>
        </el-tabs>
        <avue-crud ref="avueCrud" :data="tableData" :option="option" v-model="form" :table-loading="TABLE_LOADING" :page.sync="TABLE_PAGE" @search-change="SEARCH_CHANGE" @refresh-change="TABLE_REFRESH" @search-reset="SEARCH_RESET" @cell-click="CELL_CLICK" @selection-change="SELECTION_CHANGE" @sort-change="SORT_CHANGE" @size-change="SIZE_CHANGE" @current-change="CURRENT_CHANGE" :before-open="beforeOpen" :before-close="beforeClose" @row-update="rowUpdate" @row-save="rowSave" @row-del="rowDel">
            <template v-slot:menu="{type,size,row}">
                <el-button size="small" type="text" icon="el-icon-view" @click.stop="view(row)">查看</el-button>
                <el-button size="small" type="text" icon="el-icon-edit" @click.stop="edit(row)">编辑</el-button>
            </template>
            <template slot="xmdj" slot-scope="{row}" >
                <span v-if="row.xmdj">{{row.xmdj}}级</span>
            </template>
        </avue-crud>
        <el-dialog append-to-body width="80%" top="2vh" :close-on-click-modal="false" v-dialogDrag class="avue-dialog" :title="FORMDATAVIEW.title" :visible.sync="FORMDATAVIEW.dialogVisible"  v-if="FORMDATAVIEW.dialogVisible">
          <div class="iframeMain">
          <iframe :src="queryDataUrl" frameborder="0" height="100%"></iframe>
          </div>
        </el-dialog>
      <!-- <el-dialog append-to-body width="80%" top="2vh" :close-on-click-modal="false" v-dialogDrag class="avue-dialog" :title="FORMDATAEDIT.title" :visible.sync="FORMDATAEDIT.dialogVisible"  v-if="FORMDATAEDIT.dialogVisible">
        <div class="iframeMain">
          <iframe :src="queryDataUrl" frameborder="0" height="100%"></iframe>
        </div>
      </el-dialog> -->
    </basicContainer>
</template>

<script>
import {
  getDictionary
} from '@/businessManagement/utils/jwTools.js'
import crudPageMinix from '@/businessManagement/utils/crudPageMinix.js'
export default {
  name: 'DeliveryProjectManagement',
  mixins: [crudPageMinix],
  data() {
    return {
      queryDataUrl: '',
      FORMDATAVIEW: {
        queryData: '',
        dialogVisible: false
      },
      //   FORMDATAEDIT: {
      //     queryData: '',
      //     dialogVisible: false
      //   },
      activeName: '1',
      formid: '', // 流程表单ID
      option: {
        stripe: true,
        border: true,
        page: true,
        selection: false,
        tip: false,
        align: 'left',
        menuAlign: 'center',
        searchMenuSpan: 6,
        columnBtn: false,
        refreshBtn: true,
        labelWidth: 170,
        viewBtn: false,
        addBtn: false,
        editBtn: false,
        delBtn: false,
        menu: true,
        menuWidth: 150,
        column: [
          {
            label: '项目名称',
            prop: 'xm_mc',
            search: true,
            overHidden: true,
            searchLabelWidth: 80,
            minWidth: 120
          },
          {
            label: '客户名称',
            prop: 'kh_mc',
            search: true,
            overHidden: true,
            searchLabelWidth: 80,
            minWidth: 120
          },
          {
            label: '项目经理',
            prop: 'xm_fzr',
            search: true,
            overHidden: true,
            searchLabelWidth: 80,
            minWidth: 80
          },
          {
            label: '项目总监',
            prop: 'xmzj',
            search: true,
            overHidden: true,
            searchLabelWidth: 80,
            minWidth: 80
          },
          {
            label: '项目等级',
            prop: 'xmdj',
            overHidden: true,
            slot: true,
            search: true,
            type: 'select',
            searchLabelWidth: 80,
            minWidth: 80,
            dicData: [
              {
                label: 'A级',
                value: 'A'
              },
              {
                label: 'B级',
                value: 'B'
              },
              {
                label: 'C级',
                value: 'C'
              }
            ]
          },
          {
            label: '计划验收日期',
            prop: 'jhysrq',
            minWidth: 100,
            overHidden: true,
            type: 'date',
            format: 'yyyy-MM-dd',
            valueFormat: 'yyyy-MM-dd',
            rules: [
              {
                required: true,
                message: '请输入开始时间',
                trigger: 'blur'
              }
            ]
          },
          {
            label: '项目状态',
            prop: 'xmjfzt',
            search: true,
            overHidden: true,
            searchLabelWidth: 80,
            minWidth: 80,
            type: 'select'
          },
          {
            label: '交付里程碑',
            prop: 'lcb',
            search: true,
            overHidden: true,
            searchLabelWidth: 80,
            minWidth: 90,
            type: 'select'
          },
          {
            label: '验收状态',
            prop: 'yszk',
            search: true,
            overHidden: true,
            searchLabelWidth: 80,
            minWidth: 80,
            type: 'select'
          },
          {
            label: '更新时间',
            prop: 'gxsj',
            overHidden: true,
            minWidth: 100
          }
        //   {
        //     label: '项目说明',
        //     prop: 'xmsm',
        //     overHidden: true,
        //     minWidth: 100
        //   }
        //   {
        //     label: '合同名称',
        //     prop: 'htmc',
        //     search: true,
        //     searchLabelWidth: 130,
        //     minWidth: 300
        //   },
        //   {
        //     label: '计划验收开始日期',
        //     prop: 'jhysrq_start',
        //     search: true,
        //     searchLabelWidth: 130,
        //     minWidth: 150,
        //     type: 'date',
        //     format: 'yyyy-MM-dd',
        //     valueFormat: 'yyyy-MM-dd',
        //     rules: [
        //       {
        //         required: true,
        //         message: '请输入开始时间',
        //         trigger: 'blur'
        //       }
        //     ]
        //   },
        //   {
        //     label: '计划验收结束日期',
        //     prop: 'jhysrq_end',
        //     search: true,
        //     searchLabelWidth: 130,
        //     minWidth: 150,
        //     type: 'date',
        //     format: 'yyyy-MM-dd',
        //     valueFormat: 'yyyy-MM-dd',
        //     rules: [
        //       {
        //         required: true,
        //         message: '请输入开始时间',
        //         trigger: 'blur'
        //       }
        //     ]
        //   },
        //   {
        //     label: '客户名称',
        //     prop: 'kh_mc',
        //     search: true,
        //     searchLabelWidth: 130,
        //     minWidth: 150
        //   },
        //   {
        //     label: '交付里程碑',
        //     prop: 'lcb',
        //     search: true,
        //     searchLabelWidth: 130,
        //     minWidth: 100,
        //     type: 'select'
        //   },
        //   {
        //     label: '是否在保',
        //     prop: 'sfzb',
        //     search: true,
        //     searchLabelWidth: 130,
        //     minWidth: 100,
        //     type: 'select'
        //   },
        //   {
        //     label: '收款开始比例',
        //     prop: 'skbl_start',
        //     search: true,
        //     searchLabelWidth: 130,
        //     minWidth: 100
        //   },
        //   {
        //     label: '收款结束比例',
        //     prop: 'skbl_end',
        //     search: true,
        //     searchLabelWidth: 130,
        //     minWidth: 100
        //   },
        //   {
        //     label: '项目编号',
        //     prop: 'xmid',
        //     search: true,
        //     searchLabelWidth: 130,
        //     minWidth: 130
        //   },
        //   {
        //     label: '项目名称',
        //     prop: 'xm_mc',
        //     search: true,
        //     searchLabelWidth: 130,
        //     minWidth: 250
        //   },
        //   {
        //     label: '项目负责人工号',
        //     prop: 'xm_fzr_gh',
        //     minWidth: 130
        //   },
        //   {
        //     label: '项目负责人',
        //     prop: 'xm_fzr',
        //     search: true,
        //     searchLabelWidth: 130,
        //     minWidth: 100
        //   },
        //   {
        //     label: '项目交付状态',
        //     prop: 'xmjfzt',
        //     search: true,
        //     searchLabelWidth: 130,
        //     minWidth: 100,
        //     type: 'select'
        //   },
        //   {
        //     label: '项目总监',
        //     prop: 'xmzj',
        //     search: true,
        //     searchLabelWidth: 130,
        //     minWidth: 100
        //   },
        //   {
        //     label: '验收报告',
        //     prop: 'ysbg',
        //     search: true,
        //     searchLabelWidth: 130,
        //     minWidth: 100,
        //     type: 'select'
        //   },
        //   {
        //     label: '验收报告日期',
        //     prop: 'ysbgrq',
        //     minWidth: 100,
        //     type: 'date',
        //     format: 'yyyy-MM-dd',
        //     valueFormat: 'yyyy-MM-dd',
        //     rules: [
        //       {
        //         required: true,
        //         message: '请输入开始时间',
        //         trigger: 'blur'
        //       }
        //     ]
        //   },
        //   {
        //     label: '验收状态',
        //     prop: 'yszk',
        //     search: true,
        //     searchLabelWidth: 130,
        //     minWidth: 100,
        //     type: 'select'
        //   },
        //   {
        //     label: '发票类型',
        //     prop: 'fplx',
        //     minWidth: 100
        //   },
        //   {
        //     label: '过保日期',
        //     prop: 'gbrq',
        //     minWidth: 100,
        //     type: 'date',
        //     format: 'yyyy-MM-dd',
        //     valueFormat: 'yyyy-MM-dd',
        //     rules: [
        //       {
        //         required: true,
        //         message: '请输入开始时间',
        //         trigger: 'blur'
        //       }
        //     ]
        //   },
        //   {
        //     label: '更新人',
        //     prop: 'gxr',
        //     minWidth: 100
        //   },
        //   {
        //     label: '更新时间',
        //     prop: 'gxsj',
        //     minWidth: 150
        //   },
        //   {
        //     label: '回款条件',
        //     prop: 'hktj',
        //     minWidth: 200,
        //     hide: true
        //   },
        //   {
        //     label: '合同编号',
        //     prop: 'htbh',
        //     minWidth: 100
        //   },
        //   {
        //     label: '合同金额',
        //     prop: 'htje',
        //     minWidth: 100
        //   },
        //   {
        //     label: '合同签订日期',
        //     prop: 'htqdrq',
        //     minWidth: 100,
        //     type: 'date',
        //     format: 'yyyy-MM-dd',
        //     valueFormat: 'yyyy-MM-dd',
        //     rules: [
        //       {
        //         required: true,
        //         message: '请输入开始时间',
        //         trigger: 'blur'
        //       }
        //     ]
        //   },
        //   {
        //     label: '合同验收日期',
        //     prop: 'htysrq',
        //     minWidth: 100,
        //     type: 'date',
        //     format: 'yyyy-MM-dd',
        //     valueFormat: 'yyyy-MM-dd',
        //     rules: [
        //       {
        //         required: true,
        //         message: '请输入开始时间',
        //         trigger: 'blur'
        //       }
        //     ]
        //   },
        //   {
        //     label: '进场日期',
        //     prop: 'jcrq',
        //     minWidth: 100,
        //     type: 'date',
        //     format: 'yyyy-MM-dd',
        //     valueFormat: 'yyyy-MM-dd',
        //     rules: [
        //       {
        //         required: true,
        //         message: '请输入开始时间',
        //         trigger: 'blur'
        //       }
        //     ]
        //   },
        //   {
        //     label: '计划验收日期',
        //     prop: 'jhysrq',
        //     minWidth: 100,
        //     type: 'date',
        //     format: 'yyyy-MM-dd',
        //     valueFormat: 'yyyy-MM-dd',
        //     rules: [
        //       {
        //         required: true,
        //         message: '请输入开始时间',
        //         trigger: 'blur'
        //       }
        //     ]
        //   },
        //   {
        //     label: '开发SVN地址',
        //     prop: 'kfsvn',
        //     minWidth: 100
        //   },
        //   {
        //     label: '收款/开票情况',
        //     prop: 'kpqk',
        //     minWidth: 100
        //   },
        //   {
        //     label: '开票日期',
        //     prop: 'kprq',
        //     minWidth: 100,
        //     type: 'date',
        //     format: 'yyyy-MM-dd',
        //     valueFormat: 'yyyy-MM-dd',
        //     rules: [
        //       {
        //         required: true,
        //         message: '请输入开始时间',
        //         trigger: 'blur'
        //       }
        //     ]
        //   },
        //   {
        //     label: '里程碑开始时间',
        //     prop: 'lcbkssj',
        //     minWidth: 150,
        //     type: 'datetime',
        //     format: 'yyyy-MM-dd HH:mm:ss',
        //     valueFormat: 'yyyy-MM-dd HH:mm:ss',
        //     rules: [
        //       {
        //         required: true,
        //         message: '请输入开始时间',
        //         trigger: 'blur'
        //       }
        //     ]
        //   },
        //   {
        //     label: '历史里程碑记录',
        //     prop: 'lslcbjl',
        //     minWidth: 160
        //   },
        //   {
        //     label: '立项日期',
        //     prop: 'lxrq',
        //     minWidth: 100,
        //     type: 'date',
        //     format: 'yyyy-MM-dd',
        //     valueFormat: 'yyyy-MM-dd',
        //     rules: [
        //       {
        //         required: true,
        //         message: '请输入开始时间',
        //         trigger: 'blur'
        //       }
        //     ]
        //   },
        //   {
        //     label: '客户名称',
        //     prop: 'qykhmc',
        //     minWidth: 100
        //   },
        //   {
        //     label: '是否收回',
        //     prop: 'sfsh',
        //     minWidth: 100,
        //     type: 'select'
        //   },
        //   {
        //     label: '实际验收日期',
        //     prop: 'sjysrq',
        //     minWidth: 100,
        //     type: 'date',
        //     format: 'yyyy-MM-dd',
        //     valueFormat: 'yyyy-MM-dd',
        //     rules: [
        //       {
        //         required: true,
        //         message: '请输入开始时间',
        //         trigger: 'blur'
        //       }
        //     ]
        //   },
        //   {
        //     label: '收款比例',
        //     prop: 'skbl',
        //     minWidth: 100
        //   },
        //   {
        //     label: '收款金额',
        //     prop: 'skje',
        //     minWidth: 100
        //   },
        //   {
        //     label: '收款日期',
        //     prop: 'skrq',
        //     minWidth: 100,
        //     type: 'date',
        //     format: 'yyyy-MM-dd',
        //     valueFormat: 'yyyy-MM-dd',
        //     rules: [
        //       {
        //         required: true,
        //         message: '请输入开始时间',
        //         trigger: 'blur'
        //       }
        //     ]
        //   },
        //   {
        //     label: '实施SVN地址',
        //     prop: 'sssvn',
        //     minWidth: 100
        //   },
        //   {
        //     label: '剩余应收账款（元）',
        //     prop: 'syyszk',
        //     minWidth: 130
        //   },
        //   {
        //     label: '已开票金额（元）',
        //     prop: 'ykpje',
        //     minWidth: 130
        //   },
        //   {
        //     label: '未开票金额（元）',
        //     prop: 'wkpje',
        //     minWidth: 130
        //   },
        //   {
        //     label: '项目费用成本',
        //     prop: 'xmfycb',
        //     minWidth: 100
        //   },
        //   {
        //     label: '项目开发成本',
        //     prop: 'xmkfcb',
        //     minWidth: 100
        //   },
        //   {
        //     label: '项目说明',
        //     prop: 'xmsm',
        //     minWidth: 200
        //   },
        //   {
        //     label: '项目已发生成本（元）',
        //     prop: 'xmyfscb',
        //     minWidth: 150
        //   },
        //   {
        //     label: '项目预计成本（元）',
        //     prop: 'xmyjcb',
        //     minWidth: 150
        //   },
        //   {
        //     label: '项目总监',
        //     prop: 'xmzj',
        //     minWidth: 100
        //   },
        //   {
        //     label: '项目总监工号',
        //     prop: 'xmzjgh',
        //     minWidth: 100
        //   },
        //   {
        //     label: '销售',
        //     prop: 'xs',
        //     minWidth: 100
        //   },
        //   {
        //     label: '销售人员工号',
        //     prop: 'xsry_gh',
        //     minWidth: 100
        //   },
        //   {
        //     label: '履约/质保金（元）',
        //     prop: 'zbj',
        //     minWidth: 150
        //   },
        //   {
        //     label: '履约/质保金说明',
        //     prop: 'zbjsm',
        //     minWidth: 150
        //   },
        //   {
        //     label: '质保期',
        //     prop: 'zbq',
        //     minWidth: 100
        //   }
        ]
      },
      form: {},
      tableData: []
    }
  },
  mounted() {
    this.loadData()
    // this.$refs.tk.$el.firstChild.style.height = '90%'
    getDictionary('SFXX').then((dic) => {
      this.$set(
        this.option.column[
          this.findArray(this.option.column, 'sfsh', 'prop')
        ],
        'dicData',
        dic
      )
    })
    getDictionary('SFXX').then((dic) => {
      this.$set(
        this.option.column[
          this.findArray(this.option.column, 'sfzb', 'prop')
        ],
        'dicData',
        dic
      )
    })
    getDictionary('LCB').then((dic) => {
      this.$set(
        this.option.column[
          this.findArray(this.option.column, 'lcb', 'prop')
        ],
        'dicData',
        dic
      )
    })
    getDictionary('XMJFZT').then((dic) => {
      this.$set(
        this.option.column[
          this.findArray(this.option.column, 'xmjfzt', 'prop')
        ],
        'dicData',
        dic
      )
    })
    getDictionary('YSBG').then((dic) => {
      this.$set(
        this.option.column[
          this.findArray(this.option.column, 'ysbg', 'prop')
        ],
        'dicData',
        dic
      )
    })
    getDictionary('YSZK').then((dic) => {
      this.$set(
        this.option.column[
          this.findArray(this.option.column, 'yszk', 'prop')
        ],
        'dicData',
        dic
      )
    })
    getDictionary('FROMID').then((dic) => {
      dic.map(item => {
        if (item.value == '交付项目') {
          this.formid = item.label
        }
      })
    })
  },
  methods: {
    handleClick(tab, event) {
      this.loadData()
    },
    loadData(
      TABLE_PAGE = this.TABLE_PAGE,
      QUERY_CONDITIONS = this.QUERY_CONDITIONS,
      TABLE_ORDER = this.TABLE_ORDER,
      done,
      tabNum = this.activeName
    ) {
      this.TABLE_LOADING = true // 表格转圈
      this.QUERY_CONDITIONS.tab = tabNum || 1
      this.$http
        .post('/DeliveryProjectManage/query',
          QUERY_CONDITIONS
          , {
            params: {
              pageNum: TABLE_PAGE.currentPage,
              pageSize: TABLE_PAGE.pageSize
            }
          })
        .then((response) => {
          this.RELOAD_CRUD(response.data.records)
          this.TABLE_PAGE.total =
                        response.data.total || response.data.records.length
          this.SELECT_LIST = []
        })
        .catch((error) => {
          this.$message.error(error.msg || error.message)
        })
        .finally(() => {
          this.TABLE_LOADING = false // 表格转圈
          typeof done === 'function' && done()
        })
    },
    view(row) {
    //   this.FORMDATAVIEW.title = ' 交付项目管理查看'
    //   this.FORMDATAVIEW.dialogVisible = true
    //   this.FORMDATAVIEW.queryData = 'businessKey' + '=' + row.id + '&' + 'processInstanceId' + '&' + 'taskId' + '&' + 'formId' + '=' + this.formid + '&' + 'pageKey' + '=' + 'VIEW' + '&' + 'isHiddenBtn' + '=' + '1'
    //   this.queryDataUrl = '/#/applyViewForm?' + this.FORMDATAVIEW.queryData
      row.businessKey = row.id
      this.$router.push({
        name: 'workFlow-view-myApply',
        query: {
          businessKey: row.businessKey,
          processInstanceId: null,
          taskId: null,
          formId: this.formid,
          pageKey: 'VIEW'
        }
      })
    },
    edit(row) {
    //   this.FORMDATAEDIT.title = ' 交付项目管理编辑'
    //   this.FORMDATAEDIT.dialogVisible = true
    //   this.FORMDATAEDIT.queryData = 'businessKey' + '=' + row.id + '&' + 'processInstanceId' + '&' + 'taskId' + '&' + 'formId' + '=' + this.formid + '&' + 'pageKey' + '=' + 'DO'
    //   this.queryDataUrl = '/#/applyViewForm?' + this.FORMDATAEDIT.queryData
      row.businessKey = row.id
      this.$router.push({
        name: 'workFlow-view-myApply',
        query: {
          businessKey: row.businessKey,
          processInstanceId: null,
          taskId: null,
          formId: this.formid,
          pageKey: 'DO'
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.iframeMain{
  height: 70vh;
}

</style>
